<template>
    <div class="main noTakeaway">
        <Banner :banner="banner"/>
        <Headlines :headlines="headlines"/>

        <div class="content-box">
            <div class="left-box">
                <Article :article="broadcast"/>
                <Shuffling :swiper="coredata"/>
                <Article :article="review"/>
                <Project :project="project"/>
            </div>

            <Rightbox/>
        </div>
    </div>
</template>

<script>
export default {
    name: '2021Q2tcylcb',
    // meta配置
    metaInfo: {
        title: '【专题】' + '同程艺龙二季报：净利润同比增长103% MAU2.8亿创新高',
        meta: [
            {
                name: 'keywords',
                content: '同程艺龙 财报 收入 亏损 营收'
            },
            {
                name: 'description',
                content: '8月23日，同程艺龙（00780）发布了截至2021年6月30日的第二季度及上半年业绩报告。'
            }
        ]
    },
    data() {
        return {
            // 头图标题
            banner: {
                img: require('@/assets/2021Q2tcylcb/banner.jpg'),
                title: [
                    '同程艺龙二季报：净利润同比增长103% MAU2.8亿创新高',
                    '',
                ],
            },

            // 置顶头条
            headlines: [
                {
                    title: '同程艺龙二季报全文下载',
                    url: 'https://www1.hkexnews.hk/listedco/listconews/sehk/2021/0823/2021082300344_c.pdf'
                },
                {
                    title: '【电商快评】同程艺龙Q2财报：用长期发展策略穿越疫情影响',
                    url: '/detail--6599832.html'
                },
                {
                    title: '净利同比翻番 同程艺龙守正出奇穿越疫情影响',
                    url: '/detail--6599890.html'
                },
            ],

            // 滚动播报
            broadcast: {
                title: {
                    topic: '滚动播报',
                    more: {
                        name: '我要投诉>',
                        url: '/Index/complain.html'
                    }
                },
                params: {
                    p: 1,
                    n: 5,
                    terms: '图解财报 同程艺龙'
                },
            },

            // 核心数据
            coredata: {
                title: {
                    topic: '核心数据',
                    more: {
                        name: '更多数据>',
                        url: '/Index/dsb_product.html',
                    }
                },
                list: [
                    {
                        img: require('@/assets/2021Q2tcylcb/cb1.png'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2tcylcb/cb2.png'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2tcylcb/cb3.png'),
                        url: ''
                    },
                    {
                        img: require('@/assets/2021Q2tcylcb/cb4.png'),
                        url: ''
                    },
                ]
            },

            // 网经社点评
            review: {
                title: {
                    topic: '网经社点评',
                },
                params: {
                    p: 1,
                    n: 5,
                    terms: '陈礼腾 同程'
                },
            },

            // 相关专题
            project: {
                title: {
                    topic: '相关专题',
                },
                params: {
                    p: 1,
                    name: '行业类',
                    title: '同程'
                },
            }
        }
    },
}
</script>

<style>

</style>
